export default {
  setAuthorizationType(state, type) {
    state.authorizationType = type;
  },
  setIsPreviousDateSession(state, isPreviousDateSession) {
    state.isPreviousDateSession = isPreviousDateSession;
  },
  setPreviousDate(state, previousDate) {
    state.previousDate = previousDate;
  },
  setPreviousTime(state, previousTime) {
    state.previousTime = previousTime;
  },
  setPreviousDuration(state, previousDuration) {
    state.previousDuration = previousDuration;
  },
  setUser(state, user) {
    state.user = user;
  },
  setClientId(state, clientId) {
    state.clientId = clientId;
  },
};


// WEBPACK FOOTER //
// ./src/common/auth/vuex/mutations.js